import { render, staticRenderFns } from "./CommissionsCollector.vue?vue&type=template&id=b4c70b66"
import script from "./CommissionsCollector.vue?vue&type=script&lang=js"
export * from "./CommissionsCollector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports